<template>
    <div>
        <div class="panel animated fadeInRightBig">
            <div class="panel-heading">
                <div class="panel-title">
                    <div class="row">
                        <div class="col-md-12">
                            <span class="title">
                                Usuários da empresa: {{ domain.domain }}

                                <i class="fa fa-user-circle" style="float:right;margin-top:6px;font-size:21px;"></i>
                            </span>

                        </div>

                    </div>

                    <router-link to="/admins" class="btn btn-info" style="float:right">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                </div>
            </div>
            <div class="panel-body" v-if="loaded">
                <div>

                    <base-crud crudName="Usuarios da Empresa" newText="Novo Usuário" :table="userDomainTable"
                        :columns="columns" :options="options" :endPoint='endPoint' :enableAdd="true" :enableEdit="false"
                        :enableDelete="true" :enableView="false">
                    </base-crud>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
    components: {
        BaseCrud
    },
    data() {
        return {
            loaded: false,
            domain: {
                name: ''
            },
            userDomainTable: 'userDomainTable',
            teams: [],
            pages: [],
            url: '',
            columns: ["id", "name", "registry", "branch_id", "team_id", "email", "role_id", "qrcodevue", 'term_accepted', 'term_accepted_at', 'deleted_at', 'sign_url', "actions"],
            tableData: ["id", "name", "registry", "branch_id", "team_id", "email", "role_id", "qrcodevue", 'term_accepted', 'term_accepted_at', 'deleted_at', 'sign_url'],
            options: {
                filterable: ["id", "name", "registry", "branch_id", "team_id", "email"],
                filterByColumn: true,
                filterable: ["id", "name", "registry", "branch_id", "team_id", "email"],
                pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: "ID",
                    photo: "Foto",
                    name: "Nome",
                    registry: "Matricula",
                    qrcodevue: "QR Code",
                    team_id: "Área",
                    branch_id: "Unidade",
                    role_id: "Cargo",
                    email: "E-mail",
                    deleted_at: "Ativo",
                    term_accepted: 'Termo Aceito',
                    term_accepted_at: 'Termo aceito em',
                    sign_url: 'Assinatura de termo',
                    actions: "Ações"
                },
                templates: {
                    templates: {
                        team_id: (h, row, index) => {
                            return row.team ? row.team.name : '';
                        },
                        branch_id: (h, row, index) => {
                            return row.branch ? row.branch.name : '';
                        },
                        role_id: (h, row, index) => {
                            return row.role ? row.role.name : '';
                        },
                        term_accepted: (h, row, index) => {
                            return row.term_accepted == 1 ? 'Aceito' : 'Ainda não aceito';
                        },
                        deleted_at: (h, row, index) => {
                            return row.deleted_at == null ? 'Ativo' : 'Desativado';
                        },
                        term_accepted_at: (h, row, index) => {
                            return row.term_accepted_at ?
                                row.term_accepted_at.substr(8, 2) + '/' +
                                row.term_accepted_at.substr(5, 2) + '/' +
                                row.term_accepted_at.substr(0, 4)
                                : '';
                        }
                    },
                },
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = ["tenant"];

                    return this.$http
                        .get(this.url + '?' + query, requestData)
                        .catch(
                            function (e) {
                                this.dispatch("error", e);
                            }.bind(this)
                        );
                },
            },
            endPoint: ''
        }
    },
    computed: {},
    methods: {
        query: function (query) {
            let columns = {
                id: 'id',
                name: 'name',
                email: 'email',
                team_id: 'team[name]',
                branch_id: 'branch[name]',
                registry: 'registry',
            };
            let filters = "";
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });

            filters += "usersDeleted=" + this.usersDeleted;

            return filters;
        },
        getDomain: function () {
            let self = this;
            let id = self.$route.params.id;
            let api = self.$store.state.api + 'domains/' + id + '';

            self.endPoint = 'domains/' + id + '/users/'

            
            self.$http.get(api)
            .then((response) => {
                    self.domain = response.data.data[0];                    
                })
                .then(() => {
                    self.loaded = true;
                })
                .catch((error) => {
                    self.errors = error.response.data;
                    self.$message(null, self.errors, 'error');
                });
        }
    },
    mounted: function () {
        this.getDomain();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Domains/View.vue